module.exports = __webpack_public_path__ + "img/mn.64eb3b08.svg";